import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Input,
  OnInit
} from '@angular/core';
import { IconComponent, provideIcons, stop } from '../../../../shared/icons';
import { UnbookableReason } from '../../../entities/shop';
import { AlpitranslatePipe } from '../../../../core/pipes/alpitranslate.pipe';
import { CrowdinTranslationService } from '../../../services/crowdin-translation.service';
import { loaderMap } from './translations/loader-map';

@Component({
  selector: 'app-unbookable-info',
  templateUrl: './unbookable-info.component.html',
  styleUrls: ['./unbookable-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconComponent, AlpitranslatePipe],
  providers: [provideIcons({ stop })]
})
export class UnbookableInfoComponent implements OnInit {
  @Input() reason: UnbookableReason;
  @Input() map = false;

  constructor(
    private crowdinService: CrowdinTranslationService,
    private destroyRef: DestroyRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.crowdinService.watchLangChange({
      loaderMap: loaderMap,
      destroyRef: this.destroyRef,
      successCallback: () => {
        this.cdr.markForCheck();
      }
    });
  }
}
